import { jsx as _jsx } from "react/jsx-runtime";
import { recessTheme } from '@guildeducationinc/recess';
import { ThemeProvider } from '@mui/material/styles';
import { App, ConfigProvider } from 'antd';
import { GqlProvider, UploadProvider } from '../..';
import { AlertProvider } from '../AlertProvider';
export const Providers = ({ children, headers, gqlUrl }) => {
    return (_jsx(ConfigProvider, { theme: {
            token: {
                colorPrimary: '#e7651c',
            },
        }, children: _jsx(ThemeProvider, { theme: recessTheme, children: _jsx(UploadProvider, { children: _jsx(AlertProvider, { children: _jsx(GqlProvider, { url: gqlUrl, headers: headers, children: _jsx(App, { children: children }) }) }) }) }) }));
};
